import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.4_@playwright+test@1.57.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.4_@playwright+test@1.57.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleCard"] */ "/app/src/components/articles/articlecard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/collections/collection-list-item.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/nav-search-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/search/search-control.tsx");
